import React, { useState } from "react";
import AuthLayout from "./AuthLayout";
import { useNavigate } from "react-router-dom";
import { Button, IconButton, InputAdornment, TextField } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { VisibilityOff, Visibility } from "@mui/icons-material";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useResetPasswordMutation } from "../../services/auth";
import { showError, showToast } from "../../constants/toasts";
import { removeFromStorage } from "../../helpers/storage";
import { STORAGE_KEYS } from "../../constants/storageKeys";
import useTranslation from "../../hooks/traslation";

const ResetPassword = () => {
  const navigate = useNavigate();
  const translation = useTranslation();

  const [resetPassword] = useResetPasswordMutation();

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const formik = useFormik({
    initialValues: {
      newpassword: "",
      confirmpassword: "",
    },
    validationSchema: Yup.object({
      newpassword: Yup.string()
        .label("new Password")
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\W).{8,}$/,
          translation.auth.passLength
        )
        .required(translation.auth.newPassRequired),

      confirmpassword: Yup.string()
        .oneOf([Yup.ref("newpassword")], translation.auth.passNotMatch)
        .required(translation.auth.confrmPassRequired),
    }),
    onSubmit: async () => {
      formik.setSubmitting(true);
      const body = {
        password: formik.values.newpassword,
        // resetPassword: true,
      };

      try {
        const response = await resetPassword(body).unwrap();

        if (response?.statusCode === 200) {
          navigate("/");
          showToast(translation.auth.passwordReset);
          removeFromStorage(STORAGE_KEYS.credentials);
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (error: any) {
        showError(error?.data?.message || "");
      }
      formik.setSubmitting(false);
    },
  });

  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };
  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const handleClickShowPassword1 = () => {
    setShowConfirmPassword((prev) => !prev);
  };
  const handleMouseDownPassword1 = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  return (
    <AuthLayout>
      <div className="authBox">
        <h2>{translation.auth.resendPass}</h2>
        <p>{translation.auth.strongPass}</p>
        <form onSubmit={formik.handleSubmit}>
          <div className="control_group">
            <label>{translation.auth.newPass}</label>
            <TextField
              className="text_field"
              placeholder={translation.auth.newPass}
              fullWidth
              hiddenLabel
              type={showPassword ? "text" : "password"}
              name="newpassword"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              helperText={
                formik.touched.newpassword && formik.errors.newpassword
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end" className="eye_btn">
                    <IconButton
                      aria-label={
                        showPassword ? "Hide password" : "Show password"
                      }
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div>
          <div className="control_group">
            <label>{translation.auth.confmPas}</label>
            <TextField
              className="text_field"
              placeholder={translation.auth.confmPas}
              fullWidth
              hiddenLabel
              type={showConfirmPassword ? "text" : "password"}
              name="confirmpassword"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              helperText={
                formik.touched.confirmpassword && formik.errors.confirmpassword
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end" className="eye_btn">
                    <IconButton
                      aria-label={
                        showConfirmPassword ? "Hide password" : "Show password"
                      }
                      onClick={handleClickShowPassword1}
                      onMouseDown={handleMouseDownPassword1}
                      edge="end"
                    >
                      {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div>
          <div className="form_btn">
            <Button className="btn btn_primary w_100" type="submit">
              {translation.globals.submit}
            </Button>
          </div>
        </form>
        <div className="auth_bottom">
          <p>
            <span className="link" onClick={() => navigate("/")}>
              <KeyboardBackspaceIcon />
              {translation.auth.backToLogin}
            </span>
          </p>
        </div>
      </div>
    </AuthLayout>
  );
};

export default ResetPassword;
